type InputSettings = Pick<HTMLInputElement, 'multiple' | 'accept'>;

const DEFAULT_INPUT_SETTINGS: InputSettings = {
  multiple: false,
  accept: '',
};

const createInMemoryInput = ({
  accept = DEFAULT_INPUT_SETTINGS.accept,
  multiple = DEFAULT_INPUT_SETTINGS.multiple,
}: Partial<InputSettings> = DEFAULT_INPUT_SETTINGS) => {
  const input = document.createElement('input');

  input.type = 'file';

  input.multiple = multiple;
  input.accept = accept;

  return input;
};

export const selectFile = (
  onFileSelect: (file: File | null) => void,
  settings: Partial<InputSettings> = DEFAULT_INPUT_SETTINGS
) => {
  const input = createInMemoryInput(settings);

  const handleInputChange = () => {
    const file = input.files?.item(0) ?? null;

    onFileSelect(file);

    input.removeEventListener('change', handleInputChange);

    input.remove();
  };

  input.addEventListener('change', handleInputChange);

  input.click();
};

export const toBase64 = (file: File) =>
  new Promise<string>((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
  });
